<template>
  <Button
    :label="$t('shipment_tracking')"
    icon="pi pi-map"
    class="p-button-sm mr-2"
    @click="onShowModal()"
  />
  <CustomSidebar
    v-model:visible="showModal"
    position="bottom"
    class="p-1"
    :dismissable="false"
    exitLabel="Close"
    :title="titleLabel"
  >
    <BlockUI :blocked="isBlocked">
      <div style="min-height: 700px">
        <div></div>
        <div
          v-show="showMap"
          style="width: 100%; height: 540px"
          id="map_canvas"
        ></div>
        <div id="legend" @click= expandLegend() class="smalldesc expand"><h3 style="display:flex;align-items: flex-end;"><img src="@/assets/map.png" width="35" height="35"/> &nbsp;Legend</h3>
        <hr/>
        </div>
        <h4 v-if="!showMap" style="color: red; margin-bottom: 20px">
          {{ errMessage }}
        </h4>
      </div>
    </BlockUI>
  </CustomSidebar>
</template>
<script>
export default {
  data() {
    return {
      showModal: false,
      showMap: false,
      errMessage: "",
      dataUrl: this.$API_URL + "shipment/",
      isBlocked: false,
      shipmentNo: ""
    };
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
  },
  computed:{
    titleLabel(){
      return this.$t('shipment_tracking') + ': ' + this.shipmentNo;
    }
  },
  methods: {
    onShowModal() {
      this.errMessage = "";
      this.showModal = true;
      this.isBlocked = true;
      this.shipmentNo = this.data.Shipment_No;
      this.$axios
        .get(this.dataUrl + "tracking/" + this.data.Id)
        .then((response) => {
          this.isBlocked = false;
          var data = response.data;
          if (data.success && data.message == this.$OK) {
            this.showMap = true;
            this.initMap(data.data);
          } else if (data.success && data.message != this.$OK) {
            this.errMessage = data.message;
          } else {
            this.showModal = false;
            this.showError(data.message);
          }
        })
        .catch((err) => {
          this.isBlocked = false;
          this.showMap=false
          this.showError(err);
        });
    },
    initMap(coordinates) {
      var floatCoord = [];
      let marker = [];
      let mapContainer = document.getElementById("map_canvas");
      coordinates.forEach((coord) => {
        var temp = { lat: parseFloat(coord.lat), lng: parseFloat(coord.lng) };
        floatCoord.push(temp);
      });

      this.$maps_loader.load().then(() => {
        let map = new google.maps.Map(mapContainer, {
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          zoom: 15,
          center: new google.maps.LatLng(floatCoord[0].lat, floatCoord[0].lng),
        });

        const driverPath = new google.maps.Polyline({
          path: floatCoord,
          geodesic: true,
          strokeColor: "#FF0000",
          strokeOpacity: 1.0,
          strokeWeight: 3,
        });
        marker.push(
          new google.maps.Marker({
            position: floatCoord[floatCoord.length - 1],
            icon:this.createLegend(map),
            map,
            title: "Start Point",
          })
        );
        driverPath.setMap(map);
        this.drawDirectionRoute(floatCoord,map)
      });
    },
    createLegend(map){
      const icons = {
        source:{
          name:"Source",
          icon:require("@/assets/maps_pin_a.png")
        },
        dest:{
          name:"Destination",
          icon:require("@/assets/maps_pin_b.png")
        },
        redLine:{
          name:"Driver Path",
          icon:require("@/assets/maps_red_line.png")
        },
        blueLine:{
          name:"Recomendation Path",
          icon:require("@/assets/maps_blue_line.png")
        }
      }

      const legend = document.getElementById("legend")
      for(var key in icons){
        var type = icons[key]
        var name = type.name
        var icon = type.icon

        var div = document.createElement("div")
        div.style.cssText +="display:flex;align-items:center;margin-bottom:10px";
        div.innerHTML = `<img style="max-width:50px !important;margin-right:10px" src="${icon}"></img><span style="font-size:12px"> ${name}</span>`
        
        legend.appendChild(div)
      }

      map.controls[google.maps.ControlPosition.LEFT_TOP].push(legend)
      return icons
    },
    drawDirectionRoute(coordinates,map){
      var directionsDisplay = new google.maps.DirectionsRenderer();
      var service = new google.maps.DirectionsService();
      var start = new google.maps.LatLng(coordinates[0]);
      var end = new google.maps.LatLng(coordinates[coordinates.length - 1]);
      var request = {
        origin:start,
        destination:end,
        travelMode: google.maps.TravelMode.DRIVING
      };
      service.route(request, function(response,status){
        if(status == google.maps.DirectionsStatus.OK){
          directionsDisplay.setDirections(response)
        }
      })
      directionsDisplay.setMap(map);
    },
    expandLegend(){
      var legend = document.getElementById("legend")
      legend.classList.toggle('expand')
    },
    showError(message) {
      this.$parent.$toast.add({
        severity: "error",
        summary: "Error",
        detail: message,
        life: 120000,
      });
    },
  },
};
</script>
<style type="text/css" scoped>
#map_canvas {
  height: 100%;
}
#legend {
  font-family: Arial, sans-serif;
  background: #fff;
  padding: 10px;
  margin: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 3px #00000026;
}

#legend h3 {
  margin-top: 0;
}

#legend img {
  vertical-align: middle;
}

.smalldesc {
  margin-top: 40px !important;
  height:50px;
  width:53px;
  overflow: hidden;
  transition: width 2s,height 2s;
}

.smalldesc:hover{
  background: #dddddd !important;
}

.smalldesc.expand{
  height: 250px;
  width: 200px;
}

.smalldesc hr{
  border-color: black;
}

</style>
